module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAW0lEQVQImW3PsQ2DMBAF0DNIbqnosigpAwPAAmQgWgbIJi9FHMmy/KWrnnT3L5CxYET8J/Dyy4lUw4Sr4F5DYMZdcK0h8MCn4DZEP6m3ausdP3p1323djGf74Bei97LRORq3DQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chevron-right-white.png
// module id = 385
// module chunks = 0